import { render } from "./logo.vue?vue&type=template&id=630ee31f"
const script = {}
script.render = render

export default script